import React, {Component} from 'react';
import Header from '../Common/header';
import Content from './Content';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return(
            <div>
              <Header {...this.props}/>
              <Content route={this.props}/>
            </div>
        )
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/component/Home/index.js